import {WalletConnect as WalletConnectConnection} from '@web3-react/walletconnect-v2';
import {useCallback, useEffect} from 'react';
import {Web3ConnectionType} from '../types';
import {
  useConnectEagerly,
  useConnector,
  useInitializeConnector,
  useSwitchChain,
} from '../hooks';
import {BaseConnectorProps} from './types';

export const WalletConnect = ({
  options,
  onStateUpdate,
  chainId,
  onConnectorUpdate,
}: BaseConnectorProps<WalletConnectConnection>) => {
  const connector = useInitializeConnector(
    Web3ConnectionType.WALLET_CONNECT,
    useCallback(
      actions => {
        return new WalletConnectConnection({
          options: options.walletConnect,
          defaultChainId: options.defaultChainId,
          actions,
        });
      },
      [options.walletConnect, options.defaultChainId]
    )
  );

  useEffect(() => {
    onConnectorUpdate(connector.connector);
  }, [connector.connector, onConnectorUpdate]);

  const state = useConnector(connector, onStateUpdate);

  useConnectEagerly(connector.connector, Web3ConnectionType.WALLET_CONNECT);

  useSwitchChain(connector.connector, state, chainId);

  return null;
};
